export default "__VITE_ASSET__BD9TqCeF__"